import { z } from "zod";

import errorMessages from "../error-messages";

export const AddressSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
  city: z.string().min(1, errorMessages.required),
  address: z.string().min(1, errorMessages.required),
  postalCode: z.string().min(1, errorMessages.required),
  place_id: z.string(),
  country: z.string(),
  addressPrecision: z.string().optional(),
});

export const AddressSchemaDefaultValues = {
  latitude: 0,
  longitude: 0,
  city: "",
  address: "",
  postalCode: "",
  place_id: "",
  country: "",
  addressPrecision: "",
};
export type AddressSchemaType = z.infer<typeof AddressSchema>;
